<pdq-rules-dynamic-form
  [formGroup]="formGroup"
  [formArrayFieldName]="formArrayFieldName"
  [rules]="conditionsRules"
  [entities]="entities"
  [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
